import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { FORM_KEYS } from './queryKeys';
import type { CreateFormPayload, UpdateFormPayload } from '../types';

export function useCreateForm() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (data: CreateFormPayload) => formsService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORM_KEYS.byOrg(orgId ?? '') });
    },
  });
}

export function useDuplicateForm(formId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (title?: string) => formsService.duplicate(formId, title),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORM_KEYS.byOrg(orgId ?? '') });
    },
  });
}

export function useUpdateForm(formId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (data: UpdateFormPayload) => formsService.update(formId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORM_KEYS.detail(orgId ?? '', formId) });
      queryClient.invalidateQueries({ queryKey: FORM_KEYS.byOrg(orgId ?? '') });
    },
  });
}
